import HeroSystemBuild from "../components/HeroSystemBuild";
import Manifesto from "../components/Manifesto";
import Outcomes from "../components/Outcomes";
import CoreCapabilities from "../components/CoreCapabilities";
import WorkShowcase from "../components/WorkShowcase";
import ProcessPipeline from "../components/ProcessPipeline";
import WhyUprcse from "../components/WhyUprcse";
import CTAStartConversation from "../components/CTAStartConversation";

const Home = () => {
  return (
    <div data-testid="page-home">
      <HeroSystemBuild />
      <Manifesto />
      <Outcomes />
      <CoreCapabilities />
      <WorkShowcase />
      <ProcessPipeline />
      <WhyUprcse />
      <CTAStartConversation />
    </div>
  );
};

export default Home;
